import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHttpClient } from '../global.http.client';
import { IPage } from '../models/common/paging';
import { BaseService } from './base.service';
import { ISearchService } from './search.service';
import { Configuration } from '../configuration';
import { MatchingCaSearchRequest, MatchingCaSummaryDto, RemoveMatchDto, RemoveMatchesDto } from '../models/contract.awards/matching.contract.award.models';
import { Helpers } from '../helpers';

@Injectable()
export class MatchingContractAwardService extends BaseService implements ISearchService<MatchingCaSearchRequest,
    MatchingCaSummaryDto> {

    constructor(private readonly helpers: Helpers, http: GlobalHttpClient, private configuration: Configuration) {
        super(http);
    }

    search(request: MatchingCaSearchRequest): Observable<IPage<MatchingCaSummaryDto>> {
        return this.http.getWithParams<IPage<MatchingCaSummaryDto>>('contractAwards/mymatches', request);
    }

    removeMatch(matchId: string) {
        var response = this.http.deleteWithParams('noticeActions/removeMatch', { matchingTenderId: matchId });

        return response;
    }

    removeMatches(ids: Array<string>) {

        var response: Observable<unknown>;

        var dto = new RemoveMatchesDto();
        dto.matches = [];

        ids.forEach((id) => {
            var match = new RemoveMatchDto();
            match.matchingTenderId = id;
            dto.matches.push(match);
        });

        response = this.http.post('noticeActions/removeMatches', dto);

        return response;
    }

    checkTender(id: number) {
        return this.http.get(`contractAwards/checkContractAward/${id}`);
    }

    downloadCsv(request: MatchingCaSearchRequest) {
        var url = `${this.configuration.routing.api.baseUrl}/contractAwards/getMatchesCsv?${this.helpers.uriEncode(request)}`;
        window.location.href = url;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/matching.contract.award.service.ts